/**
 * Portuguese sentences tend to be longer than English ones (for which the recommended word limit is 20 words).
 * This is why the sentence length limit was increased to 25 for Portuguese. For more detailed explanation, see:
 * https://github.com/Yoast/research/wiki/Sentence-length-in-Portuguese
 */

export default {
	sentenceLength: {
		recommendedWordCount: 25,
	},
};
